/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Delete_TitleInputs */

const en_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete API Key`)
};

const fr_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la clé API`)
};

const de_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel löschen`)
};

const it_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina la chiave API`)
};

const ru_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить ключ API`)
};

const es_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar clave API`)
};

const zh_cn2_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除 API 密钥`)
};

const ja_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIキーを削除する`)
};

const hi_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एपीआई कुंजी हटाएं`)
};

const pt_pt2_options_api_keys_delete_title = /** @type {(inputs: Options_Api_Keys_Delete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir chave de API`)
};

/**
* | output |
* | --- |
* | "Delete API Key" |
*
* @param {Options_Api_Keys_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_delete_title = /** @type {((inputs?: Options_Api_Keys_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_delete_title(inputs)
	if (locale === "de") return de_options_api_keys_delete_title(inputs)
	if (locale === "it") return it_options_api_keys_delete_title(inputs)
	if (locale === "ru") return ru_options_api_keys_delete_title(inputs)
	if (locale === "es") return es_options_api_keys_delete_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_delete_title(inputs)
	if (locale === "ja") return ja_options_api_keys_delete_title(inputs)
	if (locale === "hi") return hi_options_api_keys_delete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_delete_title(inputs)
	return en_options_api_keys_delete_title(inputs)
});